<template>
  <div class="baseInfo">
    <p class="checkRemark" v-if="checkRemark !== ''">审核失败原因: {{ checkRemark }}</p>
    <p class="title">选择商户类型</p>
    <van-cell-group class="content">
      <van-cell v-show="isShow || merchantType === '2'" title-class="cell_left_text" @click="gotoForm('2')"
        title="小微商户" label="需提供个人身份证，银行储蓄卡" is-link />
      <van-cell v-show="isShow || merchantType === '1'" title-class="cell_left_text" @click="gotoForm('1')"
        title="个体户商户" label="需提供法人身份证，银行储蓄卡，营业执照" is-link />
      <van-cell v-show="isShow || merchantType === '0'" title-class="cell_left_text" label-class="label_text" @click="gotoForm('0')"
        title="企业商户" label="需提供法人身份证，营业执照，开户许可证等信息" is-link />
    </van-cell-group>
  </div>
</template>

<script>
import { Cell, CellGroup } from 'vant';
import CryptoJS from 'crypto-js';
export default {
  name: 'merchant_baseInfo',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  data() {
    return {
      checkRemark: '',
      pmmerId: '',
      agentId: '',
      merchantType: '',
      isShow: true
    };
  },
  created() {
    console.log(this.encryptParams('pmmerId=10001214&agentId=10001306'));
    if (window.location.href.split('?')[1]) {
      const decode = decodeURIComponent(window.location.href.split('?')[1]);
      let params = this.decryptParams(decode);
      console.log(params);
      if (~params.indexOf('pmmerId')) {
        this.pmmerId = params.split('&')[0].split('=')[1];
        this.agentId = params.split('&')[1].split('=')[1];
        this.isShow = false;
        this.queryMerchantInfo(this.pmmerId);
      }
    }
  },
  methods: {
    queryMerchantInfo(id) {
      this.$http.post({
        url: '/csps-api/merchantManage/selectMerchantById',
        data: {
          pmmerId: id
        }
      }).then(res => {
        console.log(res);
        this.$store.dispatch('submitMerchantDetail', res.data.result);
        this.merchantType = res.data.result.mercType;
        this.checkRemark = res.data.result.checkRemark;
      }).catch(error => {
        console.log(error);
      });
    },
    encryptParams(params) {
      var key = CryptoJS.enc.Base64.parse('AaBbCcDdEeFfGgHhIiJjKg==');

      var encryptedData = CryptoJS.AES.encrypt(params, key, {
        mode: CryptoJS.mode.ECB
      });

      return encryptedData.toString();
    },
    decryptParams(params) {
      var key = CryptoJS.enc.Base64.parse('AaBbCcDdEeFfGgHhIiJjKg==');

      var decrytedData = CryptoJS.AES.decrypt(params, key, {
        mode: CryptoJS.mode.ECB
      });
      var decrytedStr = decrytedData.toString(CryptoJS.enc.Utf8);
      return decrytedStr;
    },
    gotoForm(merchantType) {
      this.$store.dispatch('changeMerchantType', merchantType);
      if (this.pmmerId === '') {
        this.$store.dispatch('submitMerchantInfo', {
          "mercType": merchantType,
          "actType": merchantType === '2' ? '10B' : '10A',
        });
      } else {
        this.$store.dispatch('submitMerchantInfo', {
          "mercType": merchantType,
          "actType": merchantType === '2' ? '10B' : '10A',
          "pmmerId": this.pmmerId,
          "agentId": this.agentId
        });
      }
      this.$router.push({
        name: 'merchant_submitIdCard',
        params: {
          merchantType
        }
      });
    }
  }
};
</script>

<style scoped>
.checkRemark {
  text-align: center;
  color: red;
  padding: 10px;
}
.title{
  font-size: 20px;
  color: #464646;
  padding: 20px 0;
  font-weight: bold;
}
</style>
